module.exports = __webpack_public_path__ + "static/media/people.53415fbf.svg";